import _ from 'lodash';

type objectKey = string;
type nameInUrl = string;

const reverseMap = (map: Record<string, string>): Record<string, string> => {
  const reversedMap: Record<string, string> = {};
  for (const key in map) {
    const val = map[key];
    reversedMap[val] = key;
  }
  return reversedMap;
};

export default class UrlManager {
  get: () => string;
  set: (urlString: string, replace: boolean) => void;
  parse: (urlObject: any) => Record<string, any>;
  serialize: (urlObject: Record<string, any>) => string;
  objToUrlMap: Record<objectKey, nameInUrl>;
  urlToObjMap: Record<nameInUrl, objectKey>;

  constructor({
    getter,
    setter,
    parser,
    serializer,
    mapping,
  }: {
    getter: () => string;
    setter: (urlString: string, replace: boolean) => void;
    parser: (urlObject: any) => Record<string, any>;
    serializer: (urlObject: Record<string, any>) => string;
    mapping: Record<objectKey, nameInUrl>;
  }) {
    this.get = getter;
    this.set = setter;
    this.parse = parser;
    this.serialize = serializer;
    this.objToUrlMap = mapping;
    this.urlToObjMap = reverseMap(this.objToUrlMap);
  }

  toObjKeys(data: Record<string, any>) {
    const result: Record<string, any> = {};
    for (const el in data) {
      result[this.urlToObjMap[el]] = data[el];
    }
    return result;
  }

  toUrlKeys(data: Record<string, any>) {
    const result: Record<string, any> = {};
    for (const el in data) {
      result[this.objToUrlMap[el]] = data[el];
    }
    return result;
  }

  read() {
    const urlObj = this.get();
    const data = this.parse(urlObj);
    const result: Record<string, string> = {};
    for (const el in this.objToUrlMap) {
      const val = this.objToUrlMap[el];
      if (data[val] !== undefined) {
        result[val] = data[val];
      }
    }
    return this.toObjKeys(result);
  }

  write(newDataChunk: Record<string, any>, replace = false) {
    const data = this.read();
    const oldData = { ...data };
    for (const el in newDataChunk) {
      const val = newDataChunk[el];
      if (this.objToUrlMap[el] !== undefined && val !== undefined) {
        if (val === null) {
          delete data[el];
        } else {
          data[el] = val;
        }
      }
    }

    if (_.isEqual(data, oldData)) {
      return;
    }
    const urlObj = this.serialize(this.toUrlKeys(data));
    this.set(urlObj, replace);
  }
}
